/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { getProductData } from "../productService";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import { ExtraContent } from "../litigationCase/StatusBox/ExtraContent";
import { getButton, getContent, getPercentage } from "../litigationCase/statusBoxSteps";

export const getStatusBoxConfigGeneralCivilLaw = (generalCivilLawCase: AbstractCase) => {
  const content = getContent(generalCivilLawCase);
  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(generalCivilLawCase),
    productName: getProductData(generalCivilLawCase.name, "label"),
    percentage: getPercentage(generalCivilLawCase),
    extraContent: <ExtraContent litigationCase={generalCivilLawCase} />,
  };
};
